var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 1.82422C4.11091 1.82422 3.1875 2.74763 3.1875 3.88672V15.2405C3.1875 15.9603 3.96513 16.4117 4.59016 16.0545L8.53481 13.8004C8.82305 13.6357 9.1769 13.6357 9.46515 13.8004L13.4098 16.0545C14.0349 16.4116 14.8125 15.9604 14.8125 15.2405V3.88672C14.8125 2.74764 13.8891 1.82422 12.75 1.82422H5.25ZM4.3125 3.88672C4.3125 3.36895 4.73223 2.94922 5.25 2.94922H12.75C13.2678 2.94922 13.6875 3.36895 13.6875 3.88672V14.9174L10.0233 12.8236C9.38922 12.4613 8.61082 12.4613 7.97674 12.8236L4.3125 14.9174V3.88672Z",
    fill: "#7043FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkPurple);
export default __webpack_public_path__ + "static/media/bookmark_purple.467822f00716614540f5d4949dce92d7.svg";
export { ForwardRef as ReactComponent };